
export { default as Loader } from "./Atoms/Loader"